import { JSX } from "react";
import { ProductDetailAttributeInterface } from "../../../../interfaces/apiV2/product/ProductDetailInterface";

interface Props {
    attribute: ProductDetailAttributeInterface;
}

export const ProductSpecificationAttributeValue = ({
    attribute,
}: Props): JSX.Element => {
    if (attribute.is_bullet_points && attribute.items.length > 0) {
        return (
            <ul>
                {attribute.items.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        );
    }

    return <span>{attribute.value}</span>;
};
